import React, { useState, useRef } from "react";
import Auth from "./Auth";
import SVG from "react-inlinesvg";
import { chooseRandom } from "./Utils";
const confetti = require("canvas-confetti");

function Feedback(props) {
  // make textarea controlled
  // save it to new endpoint
  // enforce minimum
  // conditional render based on subscription status

  const [feedback, setFeedback] = useState(null);
  const [closed, setClosed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [daysAdded, setDaysAdded] = useState(null);
  const [error, setError] = useState(null);

  const cardCountNeeded = useRef(chooseRandom([1, 3, 7]));

  const MINIMUM = 15;

  function save(e) {
    e.preventDefault();

    if (!feedback || feedback.length < MINIMUM) {
      setError(`Come on. You're a writer. Surely you have a few more words in you?`);
      return;
    }

    setSubmitting(true);

    Auth.fetchWithIdToken("/api/feedback", {
      feedback: feedback,
      documentId: props.documentId,
      cardCountNeeded: cardCountNeeded.current,
    })
      .then((result) => {
        if (result.success) {
          setSubmitted(true);
          setFlipped(true);
          setDaysAdded(result.extended);

          let canvas = document.getElementById("feedback-confetti");
          canvas.confetti = canvas.confetti || confetti.create(canvas, { resize: true });
          canvas.confetti({
            spread: 60,
            particleCount: 100,
            origin: { y: 2, x: 0.5 },
          });

          props.updateNeedsFeedback(false);
        }
      })
      .catch((error) => {
        setSubmitting(false);
        setError("An unexpected error occurred.");
      });
  }

  function close(e) {
    e.preventDefault();
    setClosed(true);
    props.updateNeedsFeedback(false);
  }

  // Don't show feedback if: user has closed the card, it's dsiabled from caller, and card count is greater than what's needed

  // DISABLED UNTIL PRICING TEST IS OVER
  if (true || closed || (!props.enabled && !submitted) || props.cardCount < cardCountNeeded.current) {
    return null;
  }

  return (
    <>
      <div
        className="feedback"
        key="front"
      >
        <a
          className="close"
          onClick={close}
        >
          <SVG src="/assets/noun_X_2262986.svg" />
        </a>
        <h1>WE'RE CURIOUS</h1>
        <p>
          What made you decide to use Sudowrite? <strong>We’ll add a few days to your free trial</strong> as thanks!
        </p>

        <div className="wrapper">
          <textarea
            disabled={submitting}
            placeholder="Your thoughts here"
            onChange={(e) => {
              setFeedback(e.target.value);
            }}
          ></textarea>
          {error && <div className="error">{error}</div>}
        </div>

        <button
          disabled={submitting}
          onClick={save}
        >
          Send feedback
        </button>
      </div>

      <div
        className="feedback submitted"
        key="back"
      >
        <a
          className="close"
          onClick={close}
        >
          <SVG src="/assets/noun_X_2262986.svg" />
        </a>
        <canvas
          id="feedback-confetti"
          width="100"
          height="100"
        ></canvas>
        <h1>🎉 THANKS 🎉</h1>
        <p>We added {daysAdded} days to your trial period.</p>
      </div>
    </>
  );
}

export default Feedback;
